<template>
  <span :class="c"></span>
</template>

<script>
import { Color } from "@/const";

export default {
  name: "ColorBadge",
  props: ["color", "isSquare"],
  computed: {
    c() {
      return Object.keys(Color).reduce(
        (prev, curr) => {
          if (this.color === curr) prev[this.color] = true;
          return prev;
        },
        {
          square: this.isSquare === true,
        }
      );
    },
  },
};
</script>

<style lang="stylus" scoped>
span
  display inline-block
  border-radius 100%
  cursor pointer

  &.square
    border-radius 0

  &.green
    border 5px solid var(--epi-cal-border-green)
    background-color var(--epi-cal-border-green)

  &.cyan
    border 5px solid var(--epi-cal-border-cyan)
    background-color var(--epi-cal-border-cyan)

  &.brown
    border 5px solid var(--epi-cal-border-brown)
    background-color var(--epi-cal-border-brown)

  &.blue
    border 5px solid var(--epi-cal-border-blue)
    background-color var(--epi-cal-border-blue)

&.sand
    border 5px solid var(--epi-cal-border-sand)
    background-color var(--epi-cal-border-sand)

  &.red
    border 5px solid var(--epi-cal-border-red)
    background-color var(--epi-cal-border-red)

  &.rose
    border 5px solid var(--epi-cal-border-rose)
    background-color var(--epi-cal-border-rose)

  &.coral
    border 5px solid var(--epi-cal-border-coral)
    background-color var(--epi-cal-border-coral)

  &.yellow
    border 5px solid var(--epi-cal-border-yellow)
    background-color var(--epi-cal-border-yellow)

  &.violet
    border 5px solid var(--epi-cal-border-violet)
    background-color var(--epi-cal-border-violet)
</style>
